<template>
  <div class="slide">
    <Carousel autoplay v-model="value" loop :height="240" :autoplay-speed="autoplaySpeed" :dots="dots">
      <CarouselItem>
        <div class="demo-carousel"><img src="../../assets/img/slide01.png" alt=""></div>
      </CarouselItem>
      <CarouselItem>
       <div class="demo-carousel"><img src="../../assets/img/slide02.png" alt=""></div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel"><img src="../../assets/img/slide03.png" alt=""></div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel"><img src="../../assets/img/slide04.png" alt=""></div>
      </CarouselItem>
    </Carousel>
  </div>
</template>
<script>
export default {
    data(){
        return{
            value: 0,
            autoplaySpeed: 6000,
            dots: 'outside'
        }
    }
}
</script>
<style>
.ivu-carousel-dots li button{
    background:#31c27c !important;
    padding: 2px;
} 
.ivu-carousel-arrow-hover{ 
    background-color: rgba(49, 194, 124, 0.5) !important;
}
.slide{ 
    text-align: center;
}

.demo-carousel img {
    height: 240px;
    object-fit: cover;
}

/* 在移动端隐藏轮播图 */
@media screen and (max-width: 767px) {
    .slide {
        display: none !important;
    }
}
</style>